module.exports = __webpack_public_path__ + "img/custom.b1e3caf8.png";